import React from 'react';
import { Button, Dialog, Flex, HelpText, Link, PhoneInput, Text, createForm } from '@applyboard/crystal-ui';
import { validateCharactersLength } from "../BusinessContacts/BusinessContacts";
import { COUNTDOWN_DURATION, MIN_WHATSAPP_PHONE_NUMBER_LENGTH } from "./utils";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var _createForm = createForm(),
  Form = _createForm.Form,
  Field = _createForm.Field;
export function ChangeNumberDialog(_ref) {
  var whatsappNumber = _ref.whatsappNumber,
    onWhatsappChange = _ref.onWhatsappChange,
    verificationState = _ref.verificationState,
    updateVerificationState = _ref.updateVerificationState,
    triggerWhatsAppVerificationCode = _ref.triggerWhatsAppVerificationCode,
    startTimer = _ref.startTimer;
  var handleSubmit = function handleSubmit() {
    updateVerificationState({
      isChangeNumberDialogOpen: false,
      isVerificationDialogOpen: true,
      verificationCode: '',
      errorMessage: undefined
    });
    triggerWhatsAppVerificationCode();
    startTimer(COUNTDOWN_DURATION);
  };
  return _jsxs(Dialog, {
    open: verificationState.isChangeNumberDialogOpen,
    onOpenChange: function onOpenChange(open) {
      updateVerificationState({
        isChangeNumberDialogOpen: open
      });
      if (!open) {
        updateVerificationState({
          isVerificationDialogOpen: true
        });
      }
    },
    size: "md",
    children: [_jsx(Dialog.Heading, {
      children: "Change WhatsApp number"
    }), _jsx(Dialog.Content, {
      children: _jsx(Form, {
        defaultValues: {
          whatsappNumber: whatsappNumber
        },
        onSubmit: handleSubmit,
        id: "change-whatsapp-number-form",
        children: _jsxs(Flex, {
          direction: "column",
          gap: 8,
          children: [_jsx(Text, {
            as: "div",
            intent: "secondary",
            contrast: "high",
            variant: "bodyM",
            children: "Great! Let's add and verify your phone number. We'll send you a one-time passcode (OTP) to confirm."
          }), _jsx(Field, {
            as: PhoneInput,
            name: "whatsappNumber",
            label: "WhatsApp number",
            required: "Please enter a WhatsApp number",
            onChange: onWhatsappChange,
            validate: function validate(value) {
              var result = validateCharactersLength(value, undefined, MIN_WHATSAPP_PHONE_NUMBER_LENGTH);
              return result === true ? true : 'Please enter a valid mobile number.';
            }
          }), _jsx(HelpText, {
            children: "Enter a valid mobile number. Standard message and data rates apply."
          }), _jsx(Link, {
            href: "https://www.applyboard.com/privacy-policy",
            mode: "override_user_choice_and_open_in_new_tab",
            variant: "standalone",
            children: "Privacy policy"
          })]
        })
      })
    }), _jsxs(Dialog.Actions, {
      children: [_jsx(Dialog.CloseButton, {
        width: "fill",
        children: "Cancel"
      }), _jsx(Button, {
        form: "change-whatsapp-number-form",
        type: "submit",
        intent: "primary",
        emphasis: "contained",
        width: "fill",
        children: "Update number"
      })]
    })]
  });
}